import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { FFTableRowProps } from './types';
import { useFFTableStyles } from './styles';
import FFTableCell from './FFTableCell';

export function FFTableExpandableRow<T>({
  row,
  columns,
  onActionClick,
  rowKey,
  isExpandable = false,
  expanded = false,
  onToggleExpand,
  renderExpandedContent,
}: FFTableRowProps<T>) {
  const classes = useFFTableStyles();
  const rowId = (row as any)[rowKey];

  return (
    <>
      <TableRow 
        hover 
        tabIndex={-1} 
        key={`row-${rowId}`}
        className={`${classes.tableRow} ${expanded ? classes.expandedRow : ''}`}
      >
        <TableCell className={classes.expandIconCell}>
          {isExpandable && (
            <IconButton
              size="small"
              onClick={onToggleExpand}
              aria-label={expanded ? 'collapse row' : 'expand row'}
            >
              <ChevronRightIcon 
                className={`${classes.expandIcon} ${expanded ? classes.expandIconRotated : ''}`} 
              />
            </IconButton>
          )}
        </TableCell>
        
        {columns.filter((column) => !column.hide).map((column) => {
          const value = (row as any)[column.id];
          return (
            <FFTableCell
              key={`cell-${rowId}-${column.id}`}
              column={column}
              row={row}
              value={value}
              onActionClick={onActionClick}
            />
          );
        })}
      </TableRow>

      {isExpandable && (
        <TableRow>
          <TableCell 
            style={{ paddingBottom: 0, paddingTop: 0 }} 
            colSpan={columns.filter((column) => !column.hide).length + 1}
          >
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <div className={classes.expandedContent}>
                {renderExpandedContent && renderExpandedContent()}
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

export default FFTableExpandableRow;
